/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function AwardIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="award"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={12} cy={10} r={7.5} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.221 17.051L7 21.5L12 20.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.78 5.447C11.927 5.149 12.073 5.149 12.22 5.447L13.249 7.531C13.396 7.829 13.634 8.001 13.962 8.049L16.262 8.383C16.591 8.431 16.636 8.571 16.399 8.803L14.734 10.425C14.497 10.657 14.406 10.936 14.462 11.263L14.855 13.554C14.911 13.881 14.792 13.968 14.498 13.813L12.441 12.732C12.147 12.577 11.853 12.577 11.559 12.732L9.502 13.813C9.208 13.968 9.089 13.881 9.145 13.554L9.538 11.263C9.594 10.936 9.503 10.657 9.266 10.425L7.601 8.803C7.364 8.571 7.409 8.431 7.738 8.383L10.038 8.049C10.366 8.001 10.604 7.829 10.751 7.531L11.78 5.447Z" data-tinysvg-shape="star" data-tinysvg-star="12 10 5 5 50 0 30" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(75)} data-tinysvg-stroke-width="75" />
          <path d="M15.779 17.051L17 21.5L12 20.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
